module.exports = __webpack_public_path__ + "static/media/IMG-3.652e9db5.jpg";